import React from 'react';
import { List, ListItem, ListItemText, Typography, Box } from '@mui/material';
import moment from 'moment';

const AlertList = ({ events }) => {
  const formatTimeRange = (start, end) => {
    const startDate = moment(start);
    const endDate = moment(end);

    const startDay = startDate.format('ddd');
    const startTime = startDate.format('h:mm A');
    const endDay = endDate.format('ddd');
    const endTime = endDate.format('h:mm A');

    if (startDate.isSame(endDate, 'day')) {
      return `${startDay} ${startTime} - ${endTime}`;
    } else {
      return `${startDay} ${startTime} - ${endDay} ${endTime}`;
    }
  };

  const relevantAlerts = events.filter(
    (event) => event.severity === 'HAZARD' || event.severity === 'CRITICAL'
  );

  if (relevantAlerts.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6">No active alerts.</Typography>
      </Box>
    );
  }

  return (
    <List>
      {relevantAlerts.map((alert, index) => (
        <ListItem key={index} divider={index < relevantAlerts.length - 1}>
          <ListItemText
            primary={
              <Typography variant="body1" component="h6" fontWeight="bold">
                {alert.label}
              </Typography>
            }
            secondary={
              <Typography variant="body2" component="span" color="text.secondary">
                {formatTimeRange(alert.start, alert.end)}
              </Typography>
            }
          />
        </ListItem>
      ))}
    </List>
  );
};

export default AlertList;